var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 27,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 1.569
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M28.386 10.049H.788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.562 4.247h4.814l.01 17.207a4.046 4.046 0 0 1-4.034 4.035H4.83a4.045 4.045 0 0 1-4.034-4.035L.785 4.247h5.15M10.655 4.247h8.301"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M6.04 1.726c0-.517.424-.941.942-.941h2.542c.518 0 .942.424.942.941v3.695a.945.945 0 0 1-.942.942H6.982a.945.945 0 0 1-.942-.942V1.726ZM19.062 1.726c0-.517.424-.941.942-.941h2.54c.519 0 .943.424.943.941v3.695a.945.945 0 0 1-.942.942h-2.541a.945.945 0 0 1-.942-.942V1.726Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export default ForwardRef;